import Typography from '@mui/material/Typography'
import React from 'react'

function Footer() {
  return (
    <div className='footerSection'>
      <Typography className='copyrightText'>Copyright©2025 dr-huzaifa-khorakiwala.com. All rights reserved</Typography>
    </div>
  )
}

export default Footer
